import { Alert } from '@/ui'
import { useFlag } from '@openfeature/react-sdk'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'

type PlaidIssuesAlertFlagValue = {
  type?: 'warning' | 'error'
  title?: string
  description?: string
}

export const PlaidIssuesAlert = ({
  className = '',
}: {
  className?: string
}) => {
  const plaidIssuesAlertFlag = useFlag<PlaidIssuesAlertFlagValue>(
    FEATURE_FLAG_KEYS.plaidIssuesAlert,
    {}
  )

  const { type, title, description } = plaidIssuesAlertFlag.value

  if (!type) {
    return null
  }

  const defaultTitle = 'Issues connecting to some banks'
  const defaultDescription =
    'We are experiencing issues connecting to some banks. If you are unable to connect your account, please try again in a few days.'

  return (
    <Alert
      variant={type}
      title={title ?? defaultTitle}
      description={description ?? defaultDescription}
      dismissible
      className={className}
    />
  )
}
